import React, { useContext, useState, useEffect, useRef } from 'react';
import { Input, Form } from 'antd';
import { EditableContext } from './editableTable';
import CompSelect from './compSelect';

const EditableCell = ({
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  rowIndex,
  rule = {
    require: false,
  },
  isNumber,
  isHighlighted,
  compData,
  toggleRowIsPreset,
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef();
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editing]);

  const FieldName = `${rowIndex}-${dataIndex}`;
  const initialValueInForm = () =>
    form.setFieldsValue({
      [FieldName]: record[dataIndex],
    });
  const toggleEdit = () => {
    setEditing(!editing);
    initialValueInForm();
  };

  const isCompField = !isNumber;
  // const parseValueFromFieldValue = (feildValue) => Object.values(feildValue)[0];
  const isIncludedInComps = (value) =>
    compData.map((c) => c.companyName).includes(value);

  useEffect(() => {
    if (
      isIncludedInComps(record.companyName) &&
      FieldName.includes('companyName')
    ) {
      toggleRowIsPreset(true)(rowIndex);
    }
  }, []);

  const clearPresetData = (obj) =>
    Object.keys(obj).reduce((acc, k) => Object.assign(acc, { [k]: null }), {});

  const genModifiedDataFromCompData = (value) => {
    if (isIncludedInComps(value)) {
      toggleRowIsPreset(true)(rowIndex);
      return compData.find((c) => c.companyName === value);
    }
    toggleRowIsPreset(false)(rowIndex);
    if (isIncludedInComps(record.companyName)) {
      return Object.assign(clearPresetData(record), { companyName: value });
    }
    return { companyName: value };
  };

  const save = () => {
    const editObject = form.getFieldsValue();
    let value = editObject[FieldName];
    if (isNumber) {
      if (value != null && value !== '') {
        const parsedFloat = parseFloat(value);
        value = isNaN(parsedFloat) ? null : parseFloat(parsedFloat.toFixed(1));
      } else {
        value = null;
      }
    }
    let modifiedRecord = { [dataIndex]: value };
    if (FieldName.includes('companyName')) {
      modifiedRecord = genModifiedDataFromCompData(value);
    }
    toggleEdit();
    handleSave({
      ...Object.assign({}, record, modifiedRecord),
      rowIndex,
    });
  };

  let childNode = children;

  const isNotValidInput = (str) => {
    const length = str.length;
    if (str.charAt(length - 1) === '.') {
      return length === 1 || str.indexOf('.') !== length - 1;
    }
    return (
      !str.includes('.') &&
      ((str.length > 10 && str[0] !== '-') || str.length > 11)
    );
  };

  const numberFormatter = (e) => {
    const val = e.target.value;
    if (isNotValidInput(val)) {
      return val.slice(0, -1);
    }
    return val.replace(/[^0-9\-.]|(?!^)-/g, '');
  };

  const genChildNode = () => {
    if (!editable) {
      return childNode;
    }
    if (isCompField) {
      if (!form.getFieldsValue()[FieldName]) {
        initialValueInForm();
      }
      return (
        <Form.Item name={FieldName}>
          <CompSelect afterSelect={save} compData={compData} />
        </Form.Item>
      );
    }

    return editing ? (
      <Form.Item
        className="edit-input"
        name={FieldName}
        rules={[rule]}
        getValueFromEvent={isNumber ? numberFormatter : null}
      >
        <Input
          ref={inputRef}
          onPressEnter={save}
          onBlur={save}
          autoComplete="off"
        />
      </Form.Item>
    ) : (
      <div className="editable-cell" onClick={toggleEdit}>
        {childNode}
      </div>
    );
  };

  childNode = genChildNode();

  let tdClassName = 'edit-mode-cell';

  if (isHighlighted) {
    tdClassName += ' highlighted-col';
  }

  return (
    <td
      className={tdClassName}
      onClick={editable && !editing ? toggleEdit : () => {}}
    >
      {childNode}
    </td>
  );
};

export default EditableCell;
